import src from "IMAGE";
export default { src, width: 32, height: 21, blurWidth: 0, blurHeight: 0};
